module.exports = __webpack_public_path__ + "static/agenocrm-7c19361d7295aeadca19e5d705ed7e68.png";